$( document ).ready(function() {

  // HEIGHT VIEWPORT
  const windowHeight = document.documentElement.clientHeight;
  document.documentElement.style.setProperty('--viewport-height', `${windowHeight}px`);
  $( window ).on( "resize", function() {
    // HEIGHT VIEWPORT
    const windowHeight = document.documentElement.clientHeight;
    document.documentElement.style.setProperty('--viewport-height', `${windowHeight}px`);
  });

  // FADE IN/OUT
  window.addEventListener("beforeunload", function () {
    $("body").addClass("fade-out");
  });
  window.addEventListener("pageshow", function() {
    setTimeout(function(){
    	$("body").removeClass("fade-out");
    }, 250);
  }, false);
  setTimeout(function(){
    $("body").removeClass("fade-out");
  }, 500);

  // LAZY LOADING
  var L = [].slice.call(document.querySelectorAll('.lazy'));
  if('IntersectionObserver' in window){
    let o = new IntersectionObserver(function(E, observer){
      E.forEach(function(e){
        if(e.isIntersecting){
          let l = e.target;
          if(l.tagName == 'IMG'){
            setTimeout(function(){
              l.src = l.dataset.src;
            }, 500);
          }
          if(l.tagName == 'VIDEO'){
            var P = l.play();
            if(P !== undefined){
              P.catch(error => {
                l.controls = true;
                l.classList.add('no-autoplay');
              });
            }
          }
          l.classList.remove('lazy');
          o.unobserve(l);
        }
      });
    });
    L.forEach(function(l){
      o.observe(l);
    });
  }

  // ADD/REMOVE ITEM
  setTimeout(function(){
    $(document).on('click',  '.plus', function(e){
        var quantity = $(this).parent().find('input').val(),
          quentityDiv = $(this).parent().find('.quantity-wrap');
        quentityDiv.text(quantity);
        incrementValue(e);
    });  
    $(document).on('click',  '.minus', function(e){
        var quantity = $(this).parent().find('input').val(),
          quentityDiv = $(this).parent().find('.quantity-wrap');
        quentityDiv.text(quantity);
        decrementValue(e);
    });  
  }, 20);
  // UPDATE CART COUNT
  function updateCartCount() {
    jQuery.getJSON('/cart.js', function(cart) {
      let itemscount = cart.item_count;
      var totalmoney = cart.total_price;
      totalmoney = totalmoney.toString().slice(0,-2);
      var len = totalmoney.length;
      var symbol = $("#mini-cart").attr("data-symbol");
      var x = totalmoney.substring(0, len-3) + "," + totalmoney.substring(len-3);
      if(len < 4){
        $("#total-price-minicart").text(symbol + totalmoney);
      } else {
        $("#total-price-minicart").text(symbol + x);
      }
      if(itemscount == 0){
        $( "#cart-trigger" ).click();
        $("#cart-trigger").addClass("disabled");
        $("#mini-cart").prepend("<p class='empty-cart-text'>Your bag is empty</p>");
      } else {
        $("#cart-trigger").removeClass("disabled");
      }
      $("#cart-trigger-number").text(itemscount);
    });
  }
  // ADD PRODUCT
  function incrementValue(e) {
    e.preventDefault();
    var fieldName = $(e.target).data('field');
    var parent = $(e.target).parent('div');
    var currentVal = parseInt(parent.find('input[name="updates[]"]').val(), 10);
    var id = $(e.target).data('id');
    var maxinv = $(e.target).data("inventory")
    console.log(maxinv);

    if(currentVal >= maxinv) {
      console.log("No more stock");
    } else {
      if (!isNaN(currentVal)) {
        parent.find('input[name="updates[]"]').val(currentVal + 1);
        parent.find('.quantity-wrap').text(currentVal + 1);
        jQuery.post('/cart/change.js', {
          quantity: currentVal + 1,
          id: id
        });
      } else {
        parent.find('input[name="updates[]"]').val(0);
        parent.find('.quantity-wrap').text(0);
        jQuery.post('/cart/change.js', {
          quantity: 0,
          id: id
        });
      }
    }
    
    setTimeout(function(){
      updateCartCount();
    }, 500);
  }
  // REMOVE PRODUCT
  function decrementValue(e) {
    e.preventDefault();
    var fieldName = $(e.target).data('field');
    var parent = $(e.target).parent('div');
    var cartitem = $(e.target).closest(".mini-cart-item");
    var currentVal = parseInt(parent.find('input[name="updates[]"]').val(), 10);
    var id = $(e.target).data('id');
    
    if (!isNaN(currentVal) && currentVal > 1) {
      parent.find('input[name="updates[]"]').val(currentVal - 1);
      parent.find('.quantity-wrap').text(currentVal - 1);
      jQuery.post('/cart/change.js', {
        quantity: currentVal - 1,
        id: id
      });
    } else {
      parent.find('input[name="updates[]"]').val(0);
      parent.find('.quantity-wrap').text(0);
      jQuery.post('/cart/change.js', {
        quantity: 0,
        id: id
      });
      cartitem.remove();
    }
    setTimeout(function(){
      updateCartCount();
    }, 500);
  }

  // TOGGLE MINICART
  $( "#mini-cart-close-mobile" ).click(function() {
    $( "#mini-cart" ).removeClass("active").slideUp(300);
    $( "#menu-container" ).removeClass("show");
    $( "#cart-trigger" ).removeClass("active");
    $("body").removeClass("black-menu");
    $('#menu-mobile').removeClass('show');
    $("#burger").removeClass("active");
  });
  $( "#cart-trigger" ).click(function() {
    $( "#mini-cart" ).toggleClass("active").slideToggle(300);
    $( "#menu-container" ).removeClass("show");
    $( "#cart-trigger" ).toggleClass("active");
    $("body").removeClass("black-menu");
    $('#menu-mobile').removeClass('show');
    $("#burger").removeClass("active");
    $('#newin-container, #collection-container, #shop-container, #search-form, #about-container, #contact-container').slideUp(300);
    if($("#menu-mobile").is(".active")){
      $("#menu-trigger-mobile").children("span").toggle();
      $("#menu-mobile").slideUp().removeClass("active");
    }
  });

  // FOOTER
  $( "#footer-credits-trigger" ).click(function() {
    $('#footer-credits').slideToggle(300);
  });
  
  // MENU
  $( "#about-trigger, #about-close" ).click(function() {
    $( "#about-trigger span" ).toggle();
    $('#about-container').appendTo("#header");
    $('#about-container').slideToggle(300);
    $('#newin-container, #collection-container, #shop-container, #search-form, #contact-container').slideUp(300);
    $( "#mini-cart" ).removeClass("active").slideUp(300);
  });
  var hoverTimeoutShop;
  $("#shop-trigger, #shop-container").hover(
    function() {
      clearTimeout(hoverTimeoutShop);
      $("#shop-container").slideDown(300);
      $('#newin-container, #collection-container, #search-form, #contact-container').slideUp(300);
      $("#mini-cart").removeClass("active").slideUp(300);
    },
    function() {
      hoverTimeoutShop = setTimeout(function() {
        $("#shop-container").slideUp(300);
      }, 200);
    }
  );
  
  var hoverTimeoutNewIn;
  $("#newin-trigger, #newin-container").hover(
    function() {
      clearTimeout(hoverTimeoutNewIn);
      $("#newin-container").slideDown(300);
      $('#shop-container, #collection-container, #search-form, #contact-container').slideUp(300);
      $("#mini-cart").removeClass("active").slideUp(300);
    },
    function() {
      hoverTimeoutNewIn = setTimeout(function() {
        $("#newin-container").slideUp(300);
      }, 200);
    }
  );
  
  /*$("#collection-trigger").click(function() {
    $('#collection-container').slideToggle(300);
    $('#newin-container, #shop-container, #search-form, #contact-container').slideUp(300);
    $( "#mini-cart" ).removeClass("active").slideUp(300);
  });*/
  var hoverTimeoutCollection;
  $("#collection-trigger, #collection-container").hover(
    function() {
      clearTimeout(hoverTimeoutCollection);
      $("#collection-container").slideDown(300);
      $('#newin-container, #shop-container, #search-form, #contact-container').slideUp(300);
      $("#mini-cart").removeClass("active").slideUp(300);
    },
    function() {
      hoverTimeoutCollection = setTimeout(function() {
        $("#collection-container").slideUp(300);
      }, 200);
    }
  );
  
  $("#search-trigger-mobile").click(function() {
    if ($('#search-form').is(':visible')) {
        $(".nav-item-content").slideDown(300);
    } else {
        $(".nav-item-content, #about-container").slideUp(300);
    }
    $("#search-form").insertAfter($(this));
    $('#search-form').slideToggle(300);
    setTimeout(function(){
      $("input.search-input-text").focus();
    }, 400);
  });
  var hoverTimeoutSearch;
  var ww = $(window).width();
  $("#search-trigger, #search-form").hover(
    function() {
      clearTimeout(hoverTimeoutSearch);
      $('#search-form').slideDown(300);
      $('#newin-container, #collection-container, #shop-container, #contact-container, #about-container').slideUp(300);
      $( "#mini-cart" ).removeClass("active").slideUp(300);
      setTimeout(function(){
        $("input.search-input-text").focus();
      }, 400);
    },
    function() {
      hoverTimeoutSearch = setTimeout(function() {
        if(ww > 820){
          $("#search-form").slideUp(300);
        }
      }, 200);
    }
  );
  $("#search-close").click(function() {
    $('#search-form').slideUp(300);
  });
  
  // MENU MOBILE
  $( "#burger" ).click(function() {
    $("body").toggleClass("black-menu");
    $('#menu-mobile').toggleClass('show');
    $(this).toggleClass("active");
    $( "#mini-cart" ).removeClass("active");
  });

  // $( ".collection-link" ).hover(
  //   function() {
  //     var img = $(this).attr("data-img")
  //     if(img != ""){
  //       console.log("Contiene", img);
  //       $("<div class='hover-image-menu'><img src='" + img + "'></div>").appendTo( $(this).parent() );
  //     }
  //   }, function() {
  //     $(".hover-image-menu").remove();
  //   }
  // );

  $('.footer-link[href="/pages/about"]').click(function() {
    event.preventDefault();
    $("#about-container").appendTo("#header");
    $("#about-container").slideDown(300);
    $('#newin-container, #collection-container, #shop-container, #search-form, #contact-container').slideUp(300);
    $("#mini-cart").removeClass("active").slideUp(300);
    if($("#menu-mobile").is(".active")){
      $("#menu-trigger-mobile").children("span").toggle();
      $("#menu-mobile").slideUp().removeClass("active");
    }
  });

  $("#shop-label-mobile, #newin-label-mobile, #collection-label-mobile").click(function() {
    $(".nav-item-content").slideDown(300);
    $("#about-container, #search-form").slideUp(300);
  });

  $('#about-trigger-mobile').click(function() {
    event.preventDefault();
    if ($('#about-container').is(':visible')) {
        $(".nav-item-content").slideDown(300);
    } else {
        $(".nav-item-content, #search-form").slideUp(300);
    }
    $("#about-container").insertAfter($(this));
    $("#about-container").slideToggle(300);
  });

  var windowWidth = $(window).width();
  
  $('.footer-link[href="/pages/contact"], #contact-close').click(function() {
    event.preventDefault();
    if(windowWidth < 821){
      $("#contact-container").insertAfter($(this));
    }
    $('#newin-container, #collection-container, #shop-container, #search-form, #about-container').slideUp(300);
    $('#contact-container').slideToggle(300);
    $( "#mini-cart" ).removeClass("active").slideUp(300);
    if($("#menu-mobile").is(".active")){
      $("#menu-trigger-mobile").children("span").toggle();
      $("#menu-mobile").slideUp().removeClass("active");
    }
  });

  // MENU MOBILE
  $("#menu-trigger-mobile").click(function() {
    $(this).children("span").toggle();
    $("#menu-mobile").slideToggle().toggleClass("active");
  });
  
  // HIGHLIGHT CHANGE IMAGE MOBILE
  $(".homepage-highlight-image").click(function() {
    event.preventDefault();
    var windowWidth = $(window).width(),
        href = $(this).parent().parent('.homepage-highlight-link').attr('href'),
        el = $(this),
        src = el.attr("src");
    if(windowWidth <= 820){
      el.parent().parent().parent().children(".homepage-highlight-mobile").children(".highlight-module").children(".homepage-highlight-image").attr("src", src);
    } else {
      window.location.href = href;
    }
  });

  
  if(windowWidth > 820){
    const featuredSwiper = new Swiper('.featured-swiper', {
      direction: 'horizontal',
      loop: false,
      slidesPerView: "auto",
      spaceBetween: 15,
      mousewheel: {
        forceToAxis: true,
        sensitivity: .75,
        thresholdDelta: 50,
        thresholdTime: 50
      },
      freeMode: {
        enabled: true,
        sticky: false,
        minimumVelocity: 0.1,
        momentumRatio: 1
      },
      breakpoints: {
        820: {
          freeMode: {
            enabled: true,
            sticky: false,
            minimumVelocity: 0.1,
            momentumRatio: 5
          },
        }
      },
    });
  }
});

$( window ).on( "load", function() {
  var leftnewin = document.getElementById('newin-trigger').offsetLeft; leftnewin = leftnewin - 1;
  var leftabout = document.getElementById('about-trigger').offsetLeft; leftabout = leftabout - 1;
  var leftsearch = document.getElementById('search-trigger').offsetLeft; leftsearch = leftsearch - 1;
  var leftcollection = document.getElementById('collection-trigger').offsetLeft; leftcollection = leftcollection - 1;
  $("#about-grid").css("margin-left", leftabout + "px");
  $("#search-form").css("margin-left", leftsearch + "px");
  $("#newin-container .collection-link").css("margin-left", leftnewin + "px");
  $("#collection-container .collection-link").css("margin-left", leftcollection + "px");
});




















